module.exports = __webpack_public_path__ + "img/gys_8@2x.d8cd723.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/gys_8@2x.png
// module id = PC5Y
// module chunks = 0